import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { oauth } from '@/services';
import { setCurrentUserForOAuth } from '@/helpers/AuthHelper';
import { OAUTH_LOGIN_USER, OAUTH_SELECT_BRANCH } from '../actions-registry';
import {
	oauthLoginUserSuccess,
	oauthLoginUserError,
	oauthSelectBranchSuccess,
	oauthSelectBranchError,
} from './actions';

const loginWithEmailPasswordAsync = async (
	email,
	password,
	clientId,
	state
) => {
	const formData = new FormData();
	formData.append('username', email);
	formData.append('password', password);
	formData.append('clientId', clientId);
	formData.append('state', state);
	return oauth
		.fakeLogin(formData)
		.then((u) => u)
		.catch((error) => {
			throw error;
		});
};

function* oauthLoginWithEmailPassword({ payload }) {
	const { email, password } = payload.user;
	const { history, clientId, state } = payload;

	try {
		const loginUser = yield call(
			loginWithEmailPasswordAsync,
			email,
			password,
			clientId,
			state
		);
		yield put(oauthLoginUserSuccess(loginUser));
		setCurrentUserForOAuth(loginUser);
		history.push(`/oauth/business/${clientId}`);
	} catch (error) {
		yield put(oauthLoginUserError(error));
	}
}

export function* watchOauthLoginUser() {
	yield takeEvery(OAUTH_LOGIN_USER, oauthLoginWithEmailPassword);
}

const oauthSelectBranchWithValueAsync = async (value) => {
	const formData = new FormData();
	formData.append('username', value.username);
	formData.append('password', value.password);
	formData.append('clientId', value.clientId);
	formData.append('merchantId', value.merchantId);
	formData.append('branchId', value.branchId);
	formData.append('passBy', value.passBy);
	return oauth
		.login(formData)
		.then((data) => data)
		.catch((error) => {
			throw error;
		});
};

function* oauthSelectBranchWithValue({ payload }) {
	const { value, state } = payload;
	try {
		const selectBranch = yield call(oauthSelectBranchWithValueAsync, value);
		if (!selectBranch.message) {
			yield put(oauthSelectBranchSuccess(selectBranch));
			const val = `/oauth-api/oauth/authorize?client_id=${encodeURIComponent(
				selectBranch.clientId
			)}&state=${encodeURIComponent(state)}&redirect_uri=${encodeURIComponent(
				selectBranch.redirectUrl
			)}&response_type=code&scope=all`;
			window.open(val, '_self');
		} else {
			yield put(oauthSelectBranchError(selectBranch.message));
		}
	} catch (error) {
		yield put(oauthSelectBranchError(error));
	}
}

export function* watchOauthSelectBranch() {
	yield takeEvery(OAUTH_SELECT_BRANCH, oauthSelectBranchWithValue);
}

export default function* rootSaga() {
	yield all([fork(watchOauthLoginUser)]);
	yield all([fork(watchOauthSelectBranch)]);
}
